import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { handleGetTestimonialAction } from "@/actions/action.testimonial";
import type {
  TestimonialItem,
  TestimonialQuery,
} from "@/components/home/sections/testimonial/testimonial.type";
import { toTestimonialItem } from "@/components/home/sections/testimonial/testimonial.type";
import type { ApiResult } from "@/types/api";
import type { TestimonialRes } from "@/components/home/sections/testimonial/testimonial.type";

/** ******************************
 * Testimonial query keys
 ****************************** */
const testimonialQueryKeys = {
  listing: (params: TestimonialQuery) => ["testimonials", params] as const,
};

/** ******************************
 * Testimonial Listing
 ****************************** */
const useGetTestimonials = (params: TestimonialQuery = {}, enabled = true) => {
  return useQuery<ApiResult<TestimonialRes[]>, Error, TestimonialItem[]>({
    queryKey: testimonialQueryKeys.listing(params),
    queryFn: () => handleGetTestimonialAction(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    placeholderData: keepPreviousData,
    enabled,
    select: (res) => res.data.map(toTestimonialItem),
  });
};

export { testimonialQueryKeys, useGetTestimonials };
